<template>
  <div>
    <b-row>
      <b-col md="2">
        <validation-provider
          #default="{ errors }"
          name="Change Type"
          :vid="`${validationId}_old_party_name`"
          rules="required"
        >
          <b-form-group
            label="Change Type*"
            :state="errors.length > 0 ? false : null"
          >
            <custom-v-select
              v-model="record.changeType"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="changeTypeOptions"
              placeholder="Select Change Type"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BFormGroup,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { isEqual, cloneDeep } from 'lodash'

import CustomVSelect from '@/components/UI/CustomVSelect.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    ValidationProvider,
    CustomVSelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    validationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      record: {},
      changeTypeOptions: [
        'Credit to Cash',
        'Cash to Credit',
      ],
    }
  },
  computed: {
    out() {
      return cloneDeep(this.record)
    },
  },
  watch: {
    out: {
      handler(val) {
        if (!isEqual(val, this.value)) {
          this.$emit('input', val)
        }
      },
      deep: true,
    },
    value: {
      handler(val) {
        if (!isEqual(val, this.out)) {
          this.setInternalState()
        }
      },
      deep: true,
    },
  },
  created() {
    this.setInternalState()
  },
  methods: {
    setInternalState() {
      this.record = cloneDeep(this.value)
    },
  },
}
</script>
